import { Api } from "./_generated_";

export const client = new Api({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

export default client.api;
